p {
  margin: 0;
}

.wrapper > span[class*="hcr-tooltip-target"] {
  width: 100%;
}

.tooltip {
  white-space: normal;
}

.textContainer {
  width: 100%;

  > p,
  h1 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
